// removed by extract-text-webpack-plugin
module.exports = {"menuToggler":"menuToggler__menuToggler--3RsWE","patty":"menuToggler__patty--2gc5q","fillWhite":"menuToggler__fillWhite--2X4SS","fillRed":"menuToggler__fillRed--3HtDg","fillRedImportant":"menuToggler__fillRedImportant--qjrlA","open":"menuToggler__open--1kOMU","hamburgerHover":"menuToggler__hamburgerHover--YqHBa","is-hidden":"menuToggler__is-hidden--2qQmE","is-inverse":"menuToggler__is-inverse--1Fpzd","patties":"menuToggler__patties--3KC1r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Header/menuToggler.css
// module id = PnZL
// module chunks = 0